import { create } from 'zustand';

const initialFilters = {
  search: '',
  supplier: null,
  warehouse: null,
  is_active: '',
  inventory_is_active: '',
  date_from: '',
  date_to: '',
  ordering: 'newest',
};

const useAdminInventoryStore = create((set) => ({
  filters: initialFilters,
  page: 1,
  pageSize: 10,

  setPage: (page) => set({ page }),

  setSearch: (search) =>
    set((state) => ({
      filters: { ...state.filters, search },
      page: 1,
    })),

  setSupplier: (supplier) =>
    set((state) => ({
      filters: {
        ...state.filters,
        supplier,
        warehouse: null,
      },
      page: 1,
    })),

  setWarehouse: (warehouse) =>
    set((state) => ({
      filters: {
        ...state.filters,
        warehouse,
      },
      page: 1,
    })),

  setFilterField: (field, value) =>
    set((state) => ({
      filters: {
        ...state.filters,
        [field]: value,
      },
      page: 1,
    })),

  resetFilters: () =>
    set({
      filters: initialFilters,
      page: 1,
    }),
}));

export default useAdminInventoryStore;
